import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'app/core/services/shared.service';
import { SpinnerService } from 'app/core/services/spinner/spinner.service';
import { RedeemConfirmDialogComponent } from 'app/shared/services/dialog/redeem-confirm-dialog/redeem-confirm-dialog.component';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import moment from 'moment';
import { PaginationInstance } from 'ngx-pagination';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { SiteConfig } from '../../../../config/site-config';
import { AppState } from '../../../app.state';
import { NgxResponsiveTableConfig } from '../../../shared/components/ngx-responsive-table/models/ngx-responsive-table-config';
import { IRowColumn } from '../../../shared/components/responsive-table/models/row-column.interface';
import { NotificationType } from '../../../shared/models/notification-type';
import { AutoRedeemDialogComponent} from '../../../shared/services/dialog/auto-redeem-dialog/auto-redeem-dialog.component';
import { SuccessfulRedeemDialogComponent} from '../../../shared/services/dialog/successful-redeem-dialog/successful-redeem-dialog.component';
import { ErrorHandlerService } from '../../../shared/services/error-handler/error-handler.service';
import { FileDownloadService } from '../../../shared/services/file/file-download.service';
import { NotificationService } from '../../../shared/services/notification/notification.service';
import { User } from '../../../shared/services/user/models/user.model';
import { UtilityService } from '../../../shared/services/utility/utility.service';
import { IDwRewardShipAdvancedFilterParameter } from '../../models/dw-rewardship-advanced-filter-parameter.interface';
import { RewardshipService } from '../../services/rewardship.service';
import { TermsConditionsDialogComponent } from '../components/terms-conditions-dialog/terms-conditions-dialog.component';
import { IDigitalWalletRewardShip } from '../models/digital-wallet-rewards.interface';
import { IInvoiceSearch } from '../models/invoice-search.interface';
import { CustomPaginator } from '../services/custom-changes-paginator';
import { DigitalWalletService } from '../services/digital-wallet.service';
import { QualtricsService } from 'app/account/digital-wallet/services/qualtrics.service';


declare var $: any;

@Component({
    selector: 'upsc-dw-rewardship',
    templateUrl: './dw-rewardship.component.html',
    styleUrls: ['./dw-rewardship.component.scss'],
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    ],
})

export class DwRewardshipComponent implements OnInit, AfterViewInit, OnDestroy {
    @HostBinding('class') public hostClass = 'dw-rewardship';

    public data: any[];
    public AdvancedSearch = {};
    public checkedInvoiceLists: IDigitalWalletRewardShip[] = new Array<IDigitalWalletRewardShip>();
    public advancedInvoiceLists: IDigitalWalletRewardShip[] = new Array<IDigitalWalletRewardShip>();
    public displayedInvoiceLists: IDigitalWalletRewardShip[] = new Array<IDigitalWalletRewardShip>();
    public openInvoiceLists: IDigitalWalletRewardShip[] = new Array<IDigitalWalletRewardShip>();
    public rewardsDetails: IDigitalWalletRewardShip[] = new Array<IDigitalWalletRewardShip>();

    public categoryFormGroup: UntypedFormGroup;
    public customDateRangeFormGroup: UntypedFormGroup;
    public isDateSearch: boolean = false;
    public searchCriteria: IInvoiceSearch = {};
    public searchFormGroup: UntypedFormGroup;

    public searchCategory = ['Invoice Number', 'Invoice Date', 'Due Date', 'Balance', 'Status', 'Earned Points'];
    public paymentStatusCategory = ['Paid', 'Past Due', 'Unpaid'];
    public pointStatusCategory = ['Earned', 'Not Earned'];

    public canSearch = false;
    public checkAll = false;
    public columnNames: string[];
    public selectedColumnNames: string[];
    public pageIndex = 1;
    public pageSizes = [5, 10, 20, 50, 100];
    public dateRangeCustom = -1;
    public defaultStartDate = moment().subtract(10, 'years').startOf('day').toDate();
    public defaultEndDate = moment().toDate();
    public formattedStartDate = moment().subtract(10, 'years').startOf('day').format('MM/DD/YYYY');
    public formattedEndDate = moment().format('MM/DD/YYYY');
    public startOfStartDate = moment().add(2, 'month').startOf('day').toDate();
    public endOfStartDate = moment().add(2, 'month').endOf('day').toDate();
    public minStartDate = moment().subtract(1, 'year').startOf('day').toDate();
    public maxStartDate = this.startOfStartDate;
    public minEndDate = this.maxStartDate;
    public maxEndDate = null;
    public isSearching = false;
    public searchMode = false;
    public isLoadAllInvoices = true;
    public user: User;
    public tableConfig: NgxResponsiveTableConfig;
    public paginate: PaginationInstance;
    public totalItems = 0;
    //#region Responsive-table test
    public columns: IRowColumn[];
    public items: any[];
    public totalItemCount: number;
    public tablePageSize = 10;
    public tablePageIndex = 1;
    public isDataLoading = false;
    public dtOptions: any = {};
    public dtTrigger = new Subject();
    public availablePoints = 0;
    //#endregion
    public IsAutoRedeemToggled = false;
    public termsAndCondAccepted = true;  // Should this be initialized to false before checking API?
    //#region KPI metrics
    public currMonthRewardPts = 0;
    public currMonthRedeemPts = 0;
    public redeemPtsVar = 0;
    public rewardPtsVar = 0;
    //#region Advanced filter variables
    public closeFilterPanel$ = new Subject();
    public isApplyingAdvancedFilter = false;
    public showAdvancedFilterApply = true;
    public showAdvancedFilterPanel = false;
    public isAdvanceSearchEnabled = false;
    public minInvoiceBalance: string = '0';
    public maxInvoiceBalance: string = '100000';
    //#endregion
    public showInvoiceBalanceErrorMessage = false;
    public advancedFilterDateRangeFormGroup: UntypedFormGroup;
    public advancedFilterStartDate: string;  // Start Date string for displaying filter
    public advancedFilterEndDate: string;   // End Date string for displaying filter
    public filterStartDate = moment().subtract(14, 'day').startOf('day').toDate();
    public filterEndDate = moment().endOf('day').toDate();
    public filterMinStartDate = moment('2000-01-01').toDate();
    public filterMaxStartDate = moment().startOf('day').toDate();
    public filterMinEndDate = this.filterStartDate;
    public filterMaxEndDate = this.filterEndDate;
    public showInvoiceFilterErrorMessage = false;
    public invoiceFilterErrorMessage: string = 'Minimum value is greater than maximum value.';
    public advancedFilterCurrentMonthYear: string;  // Current month and year to display
    public advancedFilterNextMonthYear: string;     // Next month and year to display
    public dateRadioOptions = ['Invoice Date', 'Due Date'];
    public selectedDateRadioOption: string;
    public paymentStatusCategoryFormGroup: UntypedFormGroup;
    public pointStatusCategoryFormGroup: UntypedFormGroup;
    redemptionThankYouDialog: any;
    public expandDatePicker = false;
    public expandPaymentStatusDropdown = false;
    public selectedPaymentStatusOptions = [];
    public expandPointsStatusDropdown = false;
    public selectedPointsStatusOptions = [];
    private currentCategoryName = 'Invoice Number';
    private currentPage = 1;
    private pageSize = 10;
    private getInvoiceHistorySubscription: Subscription;
    private getOpenInvoiceSubscription: Subscription;
    private getAllInvoiceHistorySubscription: Subscription;
    private searchShipmentsSubscription: Subscription;
    private advancedFilterDateIndex: number = 0;    // Keeps track of current/next month and year to display
    private currentPaymentStatusCategoryName: string;
    private currentPointStatusCategoryName: string;
    private successfulRedeemDialogConfig: MatDialogConfig<any> = null;

    public shouldShowChipResetButton = false;
    //#endregion

    constructor(
        private formBuilder: UntypedFormBuilder,
        private notificationService: NotificationService,
        private utilityService: UtilityService,
        private translateService: TranslateService,
        private errorHandlerService: ErrorHandlerService,
        private digitalWalletService: DigitalWalletService,
        private dialog: MatDialog,
        private fileDownloadService: FileDownloadService,
        private sharedService: SharedService,
        private spinnerService: SpinnerService,
        private rewardShipService: RewardshipService,
        private qualtricsService: QualtricsService,
        private readonly appState: AppState,
    ) {
        this.monitorEvents();
        this.tableConfig = {
            allowDensityChange: true,
            defaultDensity: 'loose',
            small: {
                maxCollapsedColumnCount: 3,
            },
            medium: {
                isFreezeFirstColumn: true,
            },
        };
    }

    // Disable toggles for redeem buttons if no open invoices exist
    public get noAvailableInvoicesToRedeem(): boolean {
        // Get functions are continuously called over and over again, so it auto updates the disabled button and no need for boolean flag
        return (this.openInvoiceLists == null || this.openInvoiceLists.length < 1);
    }

    public ngOnInit() {
        this.qualtricsService.InsertQualtrics();
        this.dtOptions = SiteConfig.tableConfig;
        this.handleTermsAndCondOnInit();  // Check if T&C is accepted, and update page accordingly
        this.setUpForms();
        this.updatePaginateConfig();
        this.refreshData();               // Includes following methods: getInvoiceDataDefaultRange(), getDWBalance(), getOpenInvoices(), updateKPIMetrics()
        this.getAutoRedeemFlag();         // Must call handleAutoRedeem AFTER handle balance  (after this.availablePoints is updated)
        this.setUpAdvancedFilter();
    }
      

    public ngOnDestroy() {
        this.utilityService.clearSubscriptions([
            this.searchShipmentsSubscription,
            this.getInvoiceHistorySubscription,
            this.getAllInvoiceHistorySubscription,
            this.getOpenInvoiceSubscription,
        ]);
    }

    // For basic filter search
    onKeypressEvent(event: any, form) {
        if (form.selectCategory == 'Balance' || form.selectCategory == 'Earned Points') {
            var key = event.which || event.KeyCode;
            var number = event.target.value.split('.');
            return (key >= 48 && key <= 57) || (number.length == 1 && key == 46);
        }
    }

    public inputDateValidations(event: any) {
        var key = event.which || event.KeyCode;
        return (key >= 47 && key <= 57);
    }

    changeChecks(ob: MatCheckboxChange, invoiceId: string) {
        this.resetCheckBox();
        var objIndex = this.displayedInvoiceLists.findIndex((obj => obj.invoiceID === invoiceId));
        this.displayedInvoiceLists[objIndex].isChecked = ob.checked;
        this.checkAndAdd(this.displayedInvoiceLists[objIndex]);
        return;
    }

    resetCheckBox() {
        this.checkAll = false;
        const checkbox = document.getElementById(
            'checkAllCtrl',
        ) as HTMLInputElement | null;

        if (checkbox != null) {
            checkbox.checked = false;
        }
    }

    // Used in conjunction with changeChecks()
    checkAndAdd(object: IDigitalWalletRewardShip) {
        var found = this.checkedInvoiceLists.some(function (invoice) {
            return invoice.invoiceID === object.invoiceID;
        });
        if (found) {
            var objIndex = this.checkedInvoiceLists.findIndex((obj => obj.invoiceID === object.invoiceID));
            this.checkedInvoiceLists.splice(objIndex, 1);
        } else {
            this.checkedInvoiceLists.push(object);
        }
    }

    // Update check boxes in invoice table
    updateAllCheckboxes(ob: MatCheckboxChange) {
        this.checkedInvoiceLists.length = 0;

        if (ob.checked) {
            if (this.isAdvanceSearchEnabled) {
                this.getAdvancedSearchData(1, this.totalItems, false, ob.checked);
            } else {
                this.getInvoiceTableData();
            }
            this.checkAll = true;
        } else {
            this.checkAll = false;
        }

        this.displayedInvoiceLists.forEach((key) => {
            key.isChecked = ob.checked;
        });
    }

    /**
     * Called when user is trying to enable/disable auto-redeem
     * Show dialog when user toggles on/off the auto-redeem button
     * Auto-Redeem does not get toggled on until they hit "Yes" in this pop-up confirmation (while Auto-Redeem is off)
     * Auto-Redeem does not get toggled off until they hit "Yes" in this pop-up confirmation (while Auto-Redeem is on)
     */
    public toggleAutoRedeem() {
        utag.link({link_name: (this.IsAutoRedeemToggled ? "autoredeem-on" : "autoredeem-off")}); // Tag: track toggling auto-redeem
        const autoRedeemDialogConfig: MatDialogConfig = {
            disableClose: true,
            autoFocus: true,
            maxWidth: '750px',
            data: {
                dialogClass: 'mat-dialog-title',
                title: this.IsAutoRedeemToggled ? 'Turn On' : 'Turn Off',
                message: this.IsAutoRedeemToggled ? 'All future earned points will be automatically applied to new invoices as credit. If you have a balance due now, points will be applied to outstanding invoices immediately, starting with the oldest.' :
                    'Redeeming points will need to be done manually for all future invoices.',
                yesMessage: this.IsAutoRedeemToggled ? 'Yes, Turn On Auto-Redemption' : 'Yes, Turn Off Auto-Redemption',
                noMessage: this.IsAutoRedeemToggled ? 'No, Do Not Turn On Auto-Redemption' : 'No, Do Not Turn Off Auto-Redemption',
            },
        };

        const dialogRef = this.dialog.open(AutoRedeemDialogComponent, autoRedeemDialogConfig);
        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'YES') {
                utag.link({link_name: (this.IsAutoRedeemToggled ? "autoredeem-on-confirm" : "autoredeem-off-confirm")}); // Tag: track confirming auto-redeem toggle
                // If IsAutoRedeemToggled flag is true, then proceed with auto redeeming points
                // If IsAutoRedeemToggled flag is false, then call API to set auto redeem flag to false
                this.IsAutoRedeemToggled ? this.enableAutoRedeem() : this.postAutoRedeemFlag(false);
            } else {
                // If user clicks "No" on any dialog, reset flag and do nothing
                utag.link({link_name: (this.IsAutoRedeemToggled ? "autoredeem-on-cancel" : "autoredeem-off-cancel")});
                this.IsAutoRedeemToggled = !this.IsAutoRedeemToggled;
            }
        });
    }

    /**
     * Presents the customer with a pop-up to confirm they would like to redeem their points
     * Params used to pass information when users decide to only redeem one invoice in the invoice history table into redeem-confirm-dialog-component.ts
     * @param isSingleInvoice
     * @param singleInvoiceID
     * @param singleInvoiceBalance
     */
    public redeemConfirmation(isSingleInvoice: boolean = false, singleInvoiceID?: any, singleInvoiceBalance?: any) {
      if (isSingleInvoice) {
        utag.link({link_name: "redeemsec"}); // Tag: track clicking redeem button in table
      } else {
        utag.link({link_name: "redeem"}); // Tag: track clicking redeem button
      }
        if (this.openInvoiceLists == null || this.openInvoiceLists.length < 1) { //MV3-4001 show no reward points
            return;
        }
        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            data: {
                isSingleInvoice,
                singleInvoiceID,
                singleInvoiceBalance,
                title: 'Select how to redeem your points',
                yes: 'Redeem',
            },
            maxWidth: '700px',
            width: '700px',
        };

        (this.dialog.open(RedeemConfirmDialogComponent, dialogConfig)).afterClosed().subscribe(
            (result) => {
                if (result) {
                    this.onSuccessfulRedeem(result.points_to_redeem);
                }
            });
    }

    public openTermsConditionsDialog(event: any) {
        event.preventDefault();
        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '60%',
        };
        this.dialog.open(TermsConditionsDialogComponent, dialogConfig);
    }

    public acceptTermsConditions() {
        // When Continue button is clicked call Ship API (dw-73 )to set the T&C flag, hide the banner & enable the page.
        this.digitalWalletService.postTCFlag().subscribe(() => {});
        const bannerElement = document.getElementById('banner');             // Remove banner display from page
        bannerElement.remove();
        var elements = document.getElementsByClassName('content-disabled');  // Enable page display
        elements[0].classList.remove('content-disabled');
    }

    public ngAfterViewInit() {}

    /**
     * @param index
     * @param key
     * @param value
     * @param fromDate
     * @param toDate
     */
    updateInvoiceData(index: number, key?: string, value?: string, fromDate?: string, toDate?: string) {
        /* Allow Valid API call*/
        if (this.isAdvanceSearchEnabled) {
            return;
        }

        key = key.replace(' ', '');
        if (!value && ((key == 'InvoiceDate' || key == 'DueDate') && (!fromDate || fromDate == 'Invalid date'))) {
            this.isLoadAllInvoices = true;
            this.searchCriteria.categoryName = 'InvoiceDate';
            this.searchCriteria.categoryValue = '';
            this.searchCriteria.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
            this.searchCriteria.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
            this.searchCriteria.pageNumber = this.tablePageIndex;
        } else if (!value && ((key == 'InvoiceNumber' || key == 'Status' || key == 'EarnedPoints' || key == 'Balance'))) {
            this.isLoadAllInvoices = true;
            this.searchCriteria.categoryName = 'InvoiceDate';
            this.searchCriteria.categoryValue = '';
            this.searchCriteria.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
            this.searchCriteria.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
            this.searchCriteria.pageNumber = this.tablePageIndex;
        } else {
            this.searchCriteria.categoryName = key;
            this.searchCriteria.categoryValue = value;
            this.searchCriteria.startDate = fromDate;
            this.searchCriteria.endDate = toDate; // As per new changes there is only one date field search
            this.searchCriteria.pageNumber = +index;
        }

        this.searchCriteria.pageSize = this.tablePageSize;
        this.searchCriteria.inputType = 'UI';
        this.searchCriteria.isExportExcel = false;
        this.utilityService.clearSubscriptions([this.getInvoiceHistorySubscription]);
        this.isSearching = true;
        this.searchMode = false;
        this.getInvoiceHistorySubscription = this.getInvoiceHistory(+index);
    }

    /**
     * @param index
     */
    getInvoiceHistory(index: number): Subscription {
        return this.digitalWalletService.getInvoiceHistory(this.searchCriteria)
                   .subscribe(
                       (dwInvoices) => {
                           this.data = dwInvoices;
                           this.displayedInvoiceLists = <any[]>_.cloneDeep(dwInvoices);

                           if (!this.data?.length) {
                               this.displayedInvoiceLists = [];
                               this.dtTrigger.next(null);
                               this.isSearching = false;
                               this.totalItems = 0;
                               this.tablePageIndex = index;
                               this.updatePaginateConfig();
                               return;
                           }
                           this.totalItems = +dwInvoices[0].totalCount;

                           if (this.checkAll) {
                               this.displayedInvoiceLists.forEach((key) => {
                                   key.isChecked = this.checkAll;
                               });
                           } else {
                               if (this.checkedInvoiceLists.length > 0) {
                                   this.checkedInvoiceLists.forEach((key) => {
                                       var objIndex = this.displayedInvoiceLists.findIndex((obj => obj.invoiceID === key.invoiceID));
                                       if (objIndex !== -1) {
                                           this.displayedInvoiceLists[objIndex].isChecked = true;
                                       }
                                   });
                               }
                           }

                           if (this.currentCategoryName === 'Invoice Date') {
                               const clonedData = _.cloneDeep(this.data);
                               const dateRangeStart = this.utilityService.getMinMoment(clonedData.map(item => item.ShipDate));
                               const dateRangeEnd = this.utilityService.getMaxMoment(clonedData.map(item => item.ShipDate));
                               this.formattedStartDate = dateRangeStart.format('MM/DD/YYYY');
                               this.formattedEndDate = dateRangeEnd.format('MM/DD/YYYY');
                           }

                           this.tablePageIndex = +index;
                           this.updatePaginateConfig();

                           this.dtTrigger.next(null);
                           this.isSearching = false;
                       },
                       (error) => {
                           this.dtTrigger.next(null);
                           this.sendErrorNotifaction(error, 'ErrorLoadingRewardship');
                           this.isSearching = false;
                       });
    }

    getInvoiceTableData() {
        this.utilityService.clearSubscriptions([this.getAllInvoiceHistorySubscription]);
        this.searchCriteria.categoryName = 'InvoiceDate';
        this.searchCriteria.categoryValue = '';
        this.searchCriteria.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.searchCriteria.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.searchCriteria.pageNumber = this.tablePageIndex;
        this.searchCriteria.pageSize = this.totalItems;
        this.searchCriteria.inputType = 'UI';
        this.searchCriteria.isExportExcel = true;
        this.getAllInvoiceHistorySubscription = this.digitalWalletService.getAllInvoiceHistory(this.searchCriteria)
                                                    .subscribe(
                                                        (dwAllInvoices) => {
                                                            this.checkedInvoiceLists = <any[]>_.cloneDeep(dwAllInvoices);
                                                        },
                                                        (error) => {},
                                                    );
    }

    getOpenInvoices() {
        this.utilityService.clearSubscriptions([this.getOpenInvoiceSubscription]);
        this.getOpenInvoiceSubscription = this.digitalWalletService.getOpenInvoices()
                                              .subscribe(
                                                  (openInvoices) => {
                                                      this.openInvoiceLists = <any[]>_.cloneDeep(openInvoices);

                                                      if (!this.openInvoiceLists || !this.openInvoiceLists) {
                                                          return;
                                                      }
                                                  },
                                                  (error) => {
                                                      this.sendErrorNotifaction(error, 'ErrorGettingOpenInvoices');
                                                  });
        return this.openInvoiceLists;
    }

    downloadInvoice(invoiceId) {
        this.digitalWalletService.getInvoice(invoiceId.trim()).subscribe(
            (invoice) => {
                this.fileDownloadService.openPDF(invoice.InvoiceEncodedByte, 'Invoice_history.pdf');
            },
            (error) => {
                this.sendErrorNotifaction(error, 'ErrorInvoiceDownload');
            });
    }

    public exportExcel() {
        utag.link({link_name: "download"}); // Tag: track downloading the data
        if (this.isAdvanceSearchEnabled) {
            this.getAdvancedSearchData(1, this.totalItems, true);
            this.checkedInvoiceLists.length = 0;
            return;
        }
        if (this.checkedInvoiceLists.length > 0) {
            this.selectedExportExcel(this.checkedInvoiceLists);
            return;
        }
        const search: IInvoiceSearch = {};

        if (this.searchCriteria) {
            Object.keys(this.searchCriteria).forEach((key) => {
                switch (key) {
                    case 'isExportExcel':
                        search[key] = true;
                        break;
                    case 'pageSize':
                        search[key] = this.totalItems;
                        break;
                    default:
                        search[key] = this.searchCriteria[key];
                }
                ;
            });
        } else {
            let key = this.categoryFormGroup.controls.selectCategory.value.toString();
            let value = this.searchFormGroup.controls.keyword.value;
            let startDate = (key == 'Invoice Date' || key == 'Due Date') ? this.customDateRangeFormGroup.controls.startDate.value : null;
            let endDate = (key == 'Invoice Date' || key == 'Due Date') ? this.customDateRangeFormGroup.controls.endDate.value : null;

            search.categoryName = key.replace(' ', '');
            search.categoryValue = value;
            search.startDate = moment(startDate).format('YYYY-MM-DD');
            search.endDate = moment(endDate).format('YYYY-MM-DD');
            search.pageNumber = 1;
            search.pageSize = this.totalItems;
            search.inputType = 'UI';
            search.isExportExcel = true;
        }
        this.processInvoicesForExcel(search);
    }

    public selectedExportExcel(invoiceLists: IDigitalWalletRewardShip[]) {
        const exportData = [];
        const keyOrder = [
            'business',
            'invoiceNumber',
            'invoiceDate', 'dueDate',
            'balance',
            'status',
            'earnedPoints',
        ];
        const invoiceKeyToHeaderName = {
            business: 'Business',
            invoiceNumber: 'InvoiceNumber',
            invoiceDate: 'InvoiceDate',
            dueDate: 'DueDate',
            balance: 'Balance',
            status: 'Status',
            earnedPoints: 'EarnedPoints',
        };

        invoiceLists.forEach((invoice) => {
            const partDWInvoice: any = {};
            partDWInvoice.business = (invoice.business ? invoice.business.toString() : 'N/A');
            partDWInvoice.invoiceNumber = (invoice.invoiceID ? invoice.invoiceID.toString() : 'N/A');
            partDWInvoice.invoiceDate = (invoice.invoiceDate ? '\t' + moment(invoice.invoiceDate)
                .format('MM-DD-YYYY')
                .toString() : 'NULL');

            partDWInvoice.dueDate = (invoice.dueDate ? '\t' + moment(invoice.dueDate)
                .format('MM-DD-YYYY')
                .toString() : 'NULL');
            partDWInvoice.balance = (invoice.balance ? '\t$' + (+invoice.balance).toFixed(2).toString() : 'NULL');
            partDWInvoice.status = (invoice.status ? '\t' + invoice.status.toString() : 'NULL');
            partDWInvoice.earnedPoints = (invoice.points ? invoice.points.toString() + ' pts' : '0 pts');
            const partialCustomHeaderInvoices = {};

            keyOrder.forEach((key) => {
                if (invoiceKeyToHeaderName[key]) {
                    const columnName = invoiceKeyToHeaderName[key];
                    partialCustomHeaderInvoices[columnName] = partDWInvoice[key];
                }
            });

            exportData.push(partialCustomHeaderInvoices);
        });

        const csv = this.convertToCSV(exportData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

        saveAs(blob, 'invoice_history' + new Date().toLocaleDateString() + '.csv');
    }

    convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
        var row = '';

        row += 'Business,Invoice Number,Invoice Date,Due Date,Balance,Status,Earned Points';
        str += row + '\r\n'; //append columns to str and moves to next line
        str = this.fillColumns(array, str, row);
        return str;
    }

    fillColumns(array, stringToExport, row) {
        if (array && array.length > 0) {
            for (var i = 0; i < array.length; i++) {
                var line = '';
                if (row.includes('Business')) {
                    var splitBusiness = array[i].Business.replaceAll(',', ' ');
                }
                line += splitBusiness + ',';
                if (row.includes('Invoice Number')) {
                    var splitInvoiceNumber = array[i].InvoiceNumber.replaceAll(',', ' ');
                }
                line += splitInvoiceNumber + ',';
                if (row.includes('Invoice Date')) {
                    var splitinvoiceDate = array[i].InvoiceDate.replaceAll(',', ' ');
                }
                line += splitinvoiceDate + ',';
                if (row.includes('Due Date')) {
                    var splitDueDate = array[i].DueDate.replaceAll(',', ' ');
                }
                line += splitDueDate + ',';
                if (row.includes('Balance')) {
                    var splitBalance = (array[i].Balance);
                }
                line += splitBalance + ',';
                if (row.includes('Status')) {
                    var splitStatus = array[i].Status.replaceAll(',', ' ');
                }
                line += splitStatus + ',';
                if (row.includes('Earned Points')) {
                    var splitPoints = array[i].EarnedPoints;
                }
                line += splitPoints + ',';

                line = line.slice(0, -1);
                stringToExport += line + '\r\n';
            }
        }
        return stringToExport;
    }

    public onSearchSubmit(event, form) {
        event.preventDefault();
        this.isLoadAllInvoices = false;
        this.isAdvanceSearchEnabled = false;
        this.resetCheckBox();
        this.checkedInvoiceLists.length = 0;
        this.searchInvoiceHistory(1);
    }

    public onClickAdvancedFilter(closed: boolean) {
        utag.link({link_name: "filter"}); // Tag: track opening the advanced filter
        this.showAdvancedFilterPanel = !closed; // !this.showAdvancedFilterPanel;

        var elements = document.getElementsByClassName('white-content-page');
        elements[0].classList.add('content-disabled');  // Re-enable page content

        if (closed) {
            var elements = document.getElementsByClassName('white-content-page');
            elements[0].classList.remove('content-disabled');  // Re-enable page content
            this.closeFilterPanel$.next(true);
        }
    }

    public onClickDateFilter() {
        const date_picker = document.getElementById('advanced_filter_date_picker');
        date_picker.style.display = this.expandDatePicker === true ? 'block' : 'none';
        this.expandDatePicker = !this.expandDatePicker;
    }

    public onClickCalendarTable(event: any) {
        const cell = event.target?.closest('td');
        const tagElement = event.target.closest('a');

        if (!cell || !tagElement) {
            return;
        }
        // TODO: Update styling of selected date and check if new date selection is before/after start/end dates
        // event.target.style.cssText  = `cursor: pointer; color: white; border-radius: 50%; height: 25px; width: 25px; background-color: #0A8080; display: inline-block;`;

        // Parse date information contained within element
        const d = tagElement.id.split('_');
        const monthNumber = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(d[1]) + 1;
        const date_string = `${ d[0] }-${ monthNumber }-${ d[2] }`;
        // event.target.style.cssText  = `cursor: pointer; color: white; border-radius: 50%; height: 25px; width: 25px; background-color: #0A8080; display: inline-block;`;

        // If both start and end date exist already
        if (this.advancedFilterStartDate && this.advancedFilterEndDate) {
            this.advancedFilterStartDate = date_string;
            this.advancedFilterEndDate = undefined;
            console.log(this.advancedFilterStartDate, this.advancedFilterEndDate);
            return;
        }

        event.target.style.cssText = `cursor: pointer; color: white; border-radius: 50%; height: 25px; width: 25px; background-color: #0A8080; display: inline-block;`;
        // If only start date does not exist
        if (!this.advancedFilterStartDate) {
            this.advancedFilterStartDate = date_string;
            console.log(this.advancedFilterStartDate, this.advancedFilterEndDate);
            return;
        }

        // If start date exists already and end date does not exist
        if (!this.advancedFilterEndDate) {
            this.advancedFilterEndDate = date_string;
            console.log(this.advancedFilterStartDate, this.advancedFilterEndDate);
            return;
        }

        // If both start and end date exist already
        if (this.advancedFilterStartDate && this.advancedFilterEndDate) {
            this.advancedFilterStartDate = date_string;
            this.advancedFilterEndDate = undefined;
        }
    }

    public onClickNavigateDateFilter(direction: any) {
        if (direction === 'left') {
            this.advancedFilterDateIndex--;
        }
        if (direction === 'right') {
            this.advancedFilterDateIndex++;
        }
        const startDateInfo = this.getDateFilterInfo(this.advancedFilterDateIndex);
        const endDateInfo = this.getDateFilterInfo(this.advancedFilterDateIndex + 1);

        this.advancedFilterCurrentMonthYear = startDateInfo['monthName'] + ' ' + startDateInfo['year'];
        this.advancedFilterNextMonthYear = endDateInfo['monthName'] + ' ' + endDateInfo['year'];

        this.populateDateFilterTable('start_date_calendar_table', startDateInfo['daysInMonth'], startDateInfo['dayOfWeek']);
        this.populateDateFilterTable('end_date_calendar_table', endDateInfo['daysInMonth'], endDateInfo['dayOfWeek']);
    }

    public onClickStatusFilter(statusType: any) {
        if (statusType === 'Payment Status') {
            const status_options = document.getElementById('advanced_filter_payment_status_options');
            const points_status_filter = document.getElementById('points-status-filter');

            status_options.style.display = this.expandPaymentStatusDropdown === true ? 'flex' : 'none';
            this.expandPaymentStatusDropdown = !this.expandPaymentStatusDropdown;

            if (this.expandPaymentStatusDropdown) {
                points_status_filter.style.visibility = 'visible';
            } else {
                points_status_filter.style.visibility = 'hidden';
            }
        }
        if (statusType === 'Points Status') {
            const status_options = document.getElementById('advanced_filter_points_status_options');

            status_options.style.display = this.expandPointsStatusDropdown === true ? 'flex' : 'none';
            this.expandPointsStatusDropdown = !this.expandPointsStatusDropdown;
        }
    }

    public selectStatusFilter(event: any, statusType: any, value: any) {
        if (event.target.firstChild.checked !== undefined) {
            let filter_label;
            let isPaymentStatus: boolean = false;
            let isPointsStatus: boolean = false;
            let selectedStatusOption = [];

            switch (statusType) {
                case 'Payment Status':
                    filter_label = document.getElementById('advanced_filter_payment_status_label');
                    isPaymentStatus = true;
                    break;
                case 'Points Status':
                    filter_label = document.getElementById('advanced_filter_points_status_label');
                    isPointsStatus = true;
                    break;
            }
            filter_label.style.fontSize = '12px';
            filter_label.style.lineHeight = '0px';

            selectedStatusOption = isPaymentStatus ? this.selectedPaymentStatusOptions : this.selectedPointsStatusOptions;

            if (event.target.firstChild.checked === false) {
                selectedStatusOption.push(value);
                selectedStatusOption.sort();
            } else {
                const index = selectedStatusOption.indexOf(value);
                if (index >= 0) {
                    selectedStatusOption.splice(index, 1);
                }
            }
            if (selectedStatusOption.length < 1) {
                filter_label.style.fontSize = '16px';
                filter_label.style.lineHeight = '24px';
            }
            isPaymentStatus ? (this.selectedPaymentStatusOptions = selectedStatusOption) : isPointsStatus ? (this.selectedPointsStatusOptions = selectedStatusOption) : null;
        }
    }

    public applyAdvancedFilter(event: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        // Call Advanced Filter API with the selected values/options from the filter window
        // Payload may contain either all or some fields
        this.spinnerService.show();
        this.checkedInvoiceLists.length = 0;
        this.isAdvanceSearchEnabled = true;
        this.resetRegularFilterElements();

        // 1) Check if Invoice/Due Date option is selected with date values
        // TODO: New component check

        // 2) Check if Invoice Balance range inputs are provided
        this.checkAndValidateInvoiceRangeInputs();

        // 3) Check if Payment Status is provided
        this.checkAndValidatePaymentStatus();

        // 4) Check if Points Status is provided
        this.checkAndValidatePointsStatus();

        // 5) Fill in remaining fields
        this.fillRemainingAdvancedSearchFields();

        this.getAdvancedSearchData(this.tablePageIndex, this.tablePageSize, false);
        this.spinnerService.hide();
    }

    public getAdvancedSearchData(pageIndex: number,
                                 pageSize: number,
                                 isExportExcel: boolean,
                                 storeCheckedInvoiceList: boolean = false,
    ) {
        this.AdvancedSearch['pageNumber'] = pageIndex;
        this.AdvancedSearch['pageSize'] = pageSize;
        this.AdvancedSearch['isExportExcel'] = isExportExcel;
        this.digitalWalletService.postAdvancedFilter(this.AdvancedSearch)
            .pipe(
                finalize(() => {
                        this.isApplyingAdvancedFilter = false;
                    },
                ),
            )
            .subscribe(
                (response) => {
                    if (!response) {
                        return;
                    }
                    if (isExportExcel) {
                        this.advancedInvoiceLists = <any[]>_.cloneDeep(response);
                        this.selectedExportExcel(this.advancedInvoiceLists);
                    } else if (storeCheckedInvoiceList) {
                        this.checkedInvoiceLists = <any[]>_.cloneDeep(response);
                    } else {
                        this.displayedInvoiceLists = <any[]>_.cloneDeep(response);
                    }
                    if (this.displayedInvoiceLists && this.displayedInvoiceLists.length > 0) {
                        this.totalItems = +this.displayedInvoiceLists[0].totalCount;

                        // Check all the invoices to download
                        if (this.checkAll) {
                            this.displayedInvoiceLists.forEach((key) => {
                                key.isChecked = this.checkAll;
                            });
                        } else {
                            if (this.checkedInvoiceLists.length > 0) {
                                this.checkedInvoiceLists.forEach((key) => {
                                    var objIndex = this.displayedInvoiceLists.findIndex((obj => obj.invoiceID === key.invoiceID));
                                    if (objIndex !== -1) {
                                        this.displayedInvoiceLists[objIndex].isChecked = true;
                                    }
                                });
                            }
                        }
                    }

                    // Close the filter panel after applying the filter.
                    this.updatePaginateConfig();
                    const element = document.getElementById('table_filters_wrapper');
                    $(element).show();

                    this.onClickAdvancedFilter(true);
                },
            );
    }

    public resetAdvancedFilter(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.rewardShipService.advancedFilterParameterChanged$.next({});

        this.resetAdvancedFilterElements();
        this.resetCheckBox();
        this.updatePaginateConfig();
        this.refreshData();
    }

    public resetRegularFilterElements() {
        this.categoryFormGroup.controls.selectCategory.setValue('Invoice Number');
        this.customDateRangeFormGroup.controls.startDate.setValue(null);
        this.customDateRangeFormGroup.controls.endDate.setValue(null);
        this.searchFormGroup.controls.keyword.setValue('');
    }

    public onDateRadioChange(event: any) {
        if (event !== undefined || event !== null) {
            if (event.value === 'Invoice Date' || event.value === 'Due Date') {
                const element = document.getElementById('date_filter_form_container');
                $(element).show();
            }
        }
    }

    public removeAdvancedFilterOption(id: string) {
        const element = document.getElementById(id);
        $(element).hide();

        if (id == 'invoice_table_filter_date_range') {
            this.deleteInvoiceFilterDateRange();
        } else if (id == 'invoice_table_filter_invoice_balance') {
            this.deleteInvoiceFilterBalance();
        } else if (id == 'invoice_table_filter_claim_status') {
            delete this.AdvancedSearch['paymentStatus'];
            this.resetStatusFilter('Payment Status');
        } else if (id == 'invoice_table_filter_point_status') {
            delete this.AdvancedSearch['pointsStatus'];
            this.resetStatusFilter('Payment Status');
        }


        // Validation when all advanced filter options are removed, then hide container
        if (!('invoiceStartDate' in this.AdvancedSearch) && !('invoiceEndDate' in this.AdvancedSearch) && !('dueStartDate' in this.AdvancedSearch) && !('dueEndDate' in this.AdvancedSearch) &&
            !('startBalance' in this.AdvancedSearch) && !('endBalance' in this.AdvancedSearch) && !('paymentStatus' in this.AdvancedSearch) && !('pointsStatus' in this.AdvancedSearch)) {
            this.resetAdvancedFilter(null);
        } else {
            this.getAdvancedSearchData(1, this.tablePageSize, false);
        }
    }

    paginationChange(paginationDetails) {
        this.tablePageIndex = paginationDetails.pageIndex;
        this.tablePageSize = paginationDetails.pageSize;
        this.updatePaginateConfig();
        if (!this.isAdvanceSearchEnabled) {
            this.onDataSearchChanged(this.currentCategoryName);
        } else {
            this.getAdvancedSearchData(this.tablePageIndex, this.tablePageSize, false);
        }
    }

    /**
     *
     * Method uses keypress event to detect/parse user input first before displaying in field
     * @param event
     * @returns Boolean
     */
    public onKeyPressBalanceFilter(event: any) {
        // console.log(event.target.value);

        var key = event.which || event.KeyCode;
        var input = event.target.value;

        // Check first digit cannot be 0 nor '.'
        // Check if key is a decimal char
        // ONLY insert a decimal if one is not found
        if (key == 46 && event.target.selectionStart !== 0) {
            if (input.split('.').length < 2) {
                return true;
            }
        }

        // Allow any digit from 0-9
        // Check if key is a valid digit
        // For now, consider user to enter any number of digits while checkBalanceField() validates the input
        // If want to restrict digits, just need to split field by '.' delimiter and check length of number
        if (key >= 48 && key <= 57) {
            return true;
        }

        return false;
    }

    /**
     * Method uses keyup to get latest field input after a key has been released.
     * Both balance variables at this point are updated to match field inputs once keyup event is detected
     * @param event
     * @param balanceType
     */
    public checkBalanceFields() {
        // Checking that balance fields are no more than 100000
        if (+parseFloat(this.minInvoiceBalance) > 100000 || +parseFloat(this.maxInvoiceBalance) > 100000) {
            this.showInvoiceFilterErrorMessage = true;
            this.invoiceFilterErrorMessage = 'Balance field(s) cannot exceed $100000.';
            return;
        }

        // Min Invoice Balance cannot be greater than Max Invoice Balance
        // Both values must exist in the input fields for comparison
        if (+parseFloat(this.minInvoiceBalance) > +parseFloat(this.maxInvoiceBalance)) {
            this.showInvoiceFilterErrorMessage = true;
            this.invoiceFilterErrorMessage = 'Minimum value is greater than maximum value.';
            return;
        }

        this.showInvoiceFilterErrorMessage = false;
    }

    /**
     * Method uses custom change event to detect slider change for balance fields.
     * @param event
     * @param balanceType
     */
    public onSlideInvoiceBalance(event: any, balanceType: any) {
        if (balanceType === 'minBalance') {
            this.minInvoiceBalance = event;
        }
        if (balanceType === 'maxBalance') {
            this.maxInvoiceBalance = event;
        }

        this.checkBalanceFields();
    }

    public onAdvancedFilterParameterChanged(parameter: IDwRewardShipAdvancedFilterParameter) {
        if (!parameter) {
            return;
        }

        this.AdvancedSearch['startBalance'] = parameter.invoiceBalanceMin?.toFixed(2);
        this.AdvancedSearch['endBalance'] = parameter.invoiceBalanceMax?.toFixed(2);
        this.AdvancedSearch['paymentStatus'] = parameter.paymentStatuses;
        this.AdvancedSearch['pointsStatus'] = parameter.pointStatuses;

        const convertDate = (dateString: Date | null) => dayjs(dateString).isValid()
            ? dayjs(dateString).format('MM/DD/YYYY')
            : null;

        switch (parameter.dateRangeType) {
            case 'Invoice Date':
                this.AdvancedSearch['invoiceStartDate'] = convertDate(parameter.dateRangeStart);
                this.AdvancedSearch['invoiceEndDate'] = convertDate(parameter.dateRangeEnd);

                break;
            case 'Due Date':
                this.AdvancedSearch['dueStartDate'] = convertDate(parameter.dateRangeStart);
                this.AdvancedSearch['dueEndDate'] = convertDate(parameter.dateRangeEnd);

                break;
            default:
                this.AdvancedSearch['invoiceStartDate'] = null;
                this.AdvancedSearch['invoiceEndDate'] = null;
                this.AdvancedSearch['dueStartDate'] = null;
                this.AdvancedSearch['dueEndDate'] = null;

                break;
        }

        this.AdvancedSearch = Object.fromEntries(Object.entries(this.AdvancedSearch)
                                                       .filter(([key, value]) => value !== null && value !== ''));

        this.getAdvancedSearchData(this.tablePageIndex, this.tablePageSize, false);
    }

    private monitorEvents(): void {
        this.rewardShipService.advancedFilterParameterChanged$.subscribe(
            (parameter) => {
                this.onAdvancedFilterParameterChanged(parameter);

                // MV3-6022: Pagination didn't account for advance filters + Applying advanced filter does not clear basic search fields
                this.isAdvanceSearchEnabled = true;
                this.searchFormGroup.reset();
                this.customDateRangeFormGroup.reset();

                this.shouldShowChipResetButton = parameter && Object.keys(parameter)?.length > 0;
            },
        );
    }

    /**
     * Checks if the terms and conditions have been accepted when the page loads, and updates the page accordingly.
     */
    private handleTermsAndCondOnInit() {
        this.digitalWalletService.getTermsAndCondAccepted()
            .subscribe(
                (response) => {
                    this.termsAndCondAccepted = response;
                    if (response) { // Enable page display if accepted
                        var elements = document.getElementsByClassName('content-disabled');
                        elements[0]?.classList.remove('content-disabled');
                    }
                },
                (error) => {
                    this.sendErrorNotifaction(error, 'ErrorCheckingTermsAndCondAccepted');
                },
            );
    }

    /**
     * Creates forms to be displayed on the page.
     */
    private setUpForms() {
        this.searchFormGroup = this.formBuilder.group({ keyword: [''] });
        this.categoryFormGroup = this.formBuilder.group({ selectCategory: [this.currentCategoryName] });
        this.customDateRangeFormGroup = this.formBuilder.group({ startDate: [], endDate: [] });
        this.subscribeFormGroups();
    }

    /**
     * Adds functionality which will run every time 'valueChanges' is triggered
     * for categoryFormGroup, customDateRangeFormGroup, and 'searchFormGroup'
     */
    private subscribeFormGroups() {
        this.categoryFormGroup.controls.selectCategory.valueChanges
            .subscribe(
                (value) => {
                    this.tablePageIndex = 1;
                    this.currentCategoryName = value;
                    this.customDateRangeFormGroup.controls.startDate.setValue(null);
                    this.customDateRangeFormGroup.controls.endDate.setValue(null);
                    this.searchFormGroup.controls.keyword.setValue('');
                    this.canSearch = false;
                    this.isDateSearch = (value == 'Invoice Date' || value == 'Due Date');
                },
            );

        this.customDateRangeFormGroup.controls.startDate.valueChanges
            .subscribe(
                (value) => {
                    this.formattedStartDate = moment(value).format('MM/DD/YYYY');
                    if (!value) {
                        this.tablePageIndex = 1;
                        if (this.isDateSearch && !this.isAdvanceSearchEnabled) {
                            this.onDataSearchChanged(this.currentCategoryName);
                        }
                    }
                },
            );

        this.searchFormGroup.controls.keyword.valueChanges.subscribe(value => {
            if (value) {
                this.canSearch = true;
            } else {
                this.tablePageIndex = 1;
                if (!this.isDateSearch && !this.isAdvanceSearchEnabled) {
                    this.onDataSearchChanged(this.currentCategoryName);
                }
            }
        });
    }

    private updatePaginateConfig() {
        this.paginate = {
            totalItems: this.totalItems,
            currentPage: this.tablePageIndex,
            itemsPerPage: this.tablePageSize,
        };
    }

    private refreshData() {
        this.getInvoiceDataDefaultRange();
        this.getDWBalance();
        this.getOpenInvoices();
        this.updateKPIMetrics();
    }

    /**
     * Gets invoice data from defaultStartDate to defaultEndDate
     */
    private getInvoiceDataDefaultRange() {
        this.updateInvoiceData(this.pageIndex, 'InvoiceDate', '', moment(this.defaultStartDate)
            .format('YYYY-MM-DD'), moment(this.defaultEndDate).format('YYYY-MM-DD'));
    }

    /**
     * Gets customer balance using the DW API, and updates availablePoints to the new balance
     * @param customerId customer to get the balance of
     */
    private getDWBalance(): number {
        this.digitalWalletService.getDWBalance(this.appState.user$()?.CustomerId)
            .subscribe(
                (response) => {
                    // this.availablePoints = response.data.available_points;
                    this.availablePoints = response.data === null ? 0.0 : response.data.available_points; // update availablePoints, default to 0 if null
                },
                (error) => {
                    this.dtTrigger.next(null);
                    this.sendErrorNotifaction(error, 'ErrorLoadingRewardship');
                    this.isSearching = false;
                },
            );
        return this.availablePoints;
    }

    /**
     * Gets the up-to-date KPI metrics from digitalWalletService, and updates the page's values
     */
    private updateKPIMetrics() {
        this.digitalWalletService.getKPIMetrics()
            .subscribe(
                (response) => {
                    if (response.data !== null) { // update values if response is not null
                        this.currMonthRewardPts = response.data.currMonthRewardPts;
                        this.currMonthRedeemPts = response.data.currMonthRedeemPts;
                        this.redeemPtsVar = response.data.redeemPtsVar;
                        this.rewardPtsVar = response.data.rewardPtsVar;
                    }
                },
                (error) => {
                    this.sendErrorNotifaction(error, 'ErrorLoadingPointTrends');
                },
            );
    }

    /**
     * Calls the GET autoRedeem API and updates IsAutoRedeemToggled to the value recieved.
     *
     * Automatically sets IsAutoRedeemToggled to false if availablePoints < 1
     */
    private getAutoRedeemFlag() {
        this.digitalWalletService.getAutoRedeemFlag(this.appState.user$()?.CustomerId)
            .subscribe(
                (response) => {
                    this.IsAutoRedeemToggled = response.data;
                },
                (error) => {
                    this.sendErrorNotifaction(error, 'ErrorGettingAutoRedeemFlag');
                },
            );
    }

    /**
     * Set up components within the advanced filter.
     */
    private setUpAdvancedFilter() {
        var element = document.getElementById('table_filters_wrapper');
        $(element).hide();

        // Initial setup for days of the starting and ending month
        const startDateInfo = this.getDateFilterInfo(this.advancedFilterDateIndex);
        const endDateInfo = this.getDateFilterInfo(this.advancedFilterDateIndex + 1);
        // console.log(startDateInfo);
        // console.log(endDateInfo);

        this.advancedFilterCurrentMonthYear = startDateInfo['monthName'] + ' ' + startDateInfo['year'];
        this.advancedFilterNextMonthYear = endDateInfo['monthName'] + ' ' + endDateInfo['year'];

        this.populateDateFilterTable('start_date_calendar_table', startDateInfo['daysInMonth'], startDateInfo['dayOfWeek']);
        this.populateDateFilterTable('end_date_calendar_table', endDateInfo['daysInMonth'], endDateInfo['dayOfWeek']);

        element = document.getElementById('date_filter_form_container');
        $(element).hide();

        this.closeFilterPanel$.subscribe(
            () => {
                this.isApplyingAdvancedFilter = false;
                this.showAdvancedFilterPanel = false;
                this.showAdvancedFilterApply = true;
            },
        );
    }

    private getDateFilterInfo(index: number) {
        const monthInfo = moment().add(index, 'month').startOf('month');
        const d = {
            'monthName': monthInfo.format('MMMM'),
            'monthNumber': monthInfo.format('MM'),
            'day': monthInfo.format('DD'),
            'dayOfWeek': monthInfo.format('dd'),
            'daysInMonth': monthInfo.daysInMonth(),
            'year': monthInfo.format('YYYY'),
        };
        return d;
    }

    private populateDateFilterTable(elementId: string, numDays: any, dayOfWeek: string) {
        const table = document.getElementById(elementId) as HTMLTableElement;
        if (!table) {
            return;
        }

        const numRows = table.rows.length;
        // console.log(numRows);

        // Delete existing rows of table data
        if (numRows > 1) {
            for (var i = 1; i < numRows; i++) {
                table.deleteRow(1);
            }
        }

        const daysOfWeekIndices = {
            'Su': 0,
            'Mo': 1,
            'Tu': 2,
            'We': 3,
            'Th': 4,
            'Fr': 5,
            'Sa': 6,
        };
        var beginIndex = daysOfWeekIndices[dayOfWeek];
        // console.log(dayOfWeek, beginIndex);

        var row = table.insertRow(1);
        var rowIndex = 2;

        // TODO: Fill in empty cells before/after start/end days of month with previous/next month days
        // Won't be able to insert cells at other indices unless filling in the preceding ones
        for (var i = 0; i < beginIndex; i++) {
            const cell = row.insertCell(i);
            cell.innerHTML = '';
        }

        var dayNumber = 1;
        while (dayNumber <= numDays) {
            for (var i = beginIndex; i < 7; i++) {
                if (dayNumber > numDays) {
                    return;
                }
                const cellLink = document.createElement('a');  // Dynamically create anchor tag for each day number to act as selection
                cellLink.innerHTML = dayNumber.toString();

                if (elementId === 'start_date_calendar_table') {
                    const d = this.advancedFilterCurrentMonthYear.split(' ');
                    cellLink.setAttribute('id', `${ d[1] }_${ d[0] }_${ dayNumber.toString() }`);
                }

                if (elementId === 'end_date_calendar_table') {
                    const d = this.advancedFilterNextMonthYear.split(' ');
                    cellLink.setAttribute('id', `${ d[1] }_${ d[0] }_${ dayNumber.toString() }`);
                }

                const cell = row.insertCell(i);
                cell.appendChild(cellLink);
                cell.addEventListener('mouseover', () => {
                    cell.style.cssText = `cursor: pointer; color: black; border-radius: 50%; height: 25px; width: 25px; background-color: #b3e0dc; display: inline-block;`;
                });
                cell.addEventListener('mouseleave', () => {
                    cell.style.cssText = `cursor: pointer; color: black`;
                });

                dayNumber++;
            }

            row = table.insertRow(rowIndex);
            beginIndex = 0;
            rowIndex++;
        }

    }

    private sendErrorNotifaction(error: any, message: string) {
        this.notificationService.notify(
            this.errorHandlerService.getHttpErrorMessage(error),
            this.translateService.instant(message),
            NotificationType.ERROR,
        );
    }

    private postAutoRedeemFlag(flag: boolean) {
        this.digitalWalletService.postAutoRedeemFlag(this.appState.user$()?.CustomerId, flag)
            .subscribe(
                (response) => {},
                (error) => {
                    this.sendErrorNotifaction(error, 'ErrorUpdatingAutoRedeemFlag');
                },
            );
        this.IsAutoRedeemToggled = flag;
    }

    private async enableAutoRedeem() {
        this.postAutoRedeemFlag(true); // Disable manual redeem button. (Enables/Disables based on isAutoRedeemToggled flag)

        if (this.availablePoints >= 1 && this.openInvoiceLists !== null && this.openInvoiceLists.length > 0) {
            var totalPointsApplied = await this.autoRedeemInvoices();  // If customer has available points and open invoices, then automatically redeem them
            this.onSuccessfulRedeem(totalPointsApplied);
        }
    }

    /**
     * Auto redeems invoices until the customer either has no points remaining, or no outstanding balance
     * @returns total points redeemed
     */
    private async autoRedeemInvoices(): Promise<number> {
        this.spinnerService.show();
        var totalPointsApplied = 0;

        // Call POST redeem API in a loop, starting from the oldest due date
        // runs until no points are left, or there are no invoices with an outstanding balance.
        for (var i = 0; i < this.openInvoiceLists.length && this.availablePoints > 0; i++) {
            var balance = parseFloat(this.openInvoiceLists[i].balance);
            var pointsToRedeem = Math.min(this.availablePoints, balance);  // Gets oldest invoice balance

            totalPointsApplied += pointsToRedeem;
            this.availablePoints -= pointsToRedeem;

            await this.postRedeem({
                customerid: this.appState.user$()?.CustomerId,
                points_to_redeem: pointsToRedeem.toFixed(2),
                invoiceid: this.openInvoiceLists[i].invoiceID,
            });
        }

        this.spinnerService.hide();
        return totalPointsApplied;
    }

    /**
     * Calls the POST redeem API. Redeems based on the specified data
     * @param data object containing customerid, points_to_redeem, and invoiceid
     */
    private async postRedeem(data: any) {
        await this.digitalWalletService.postRedeem(data)
                  .pipe(
                      catchError((error) => {
                          this.sendErrorNotifaction(error, 'ErrorPostRedeem');
                          return of(null);
                      }),
                  ).toPromise();
    }

    /**
     * Displays a pop-up thanking the user for redeeming points
     * Creates the SuccessfulRedeemDialogConfig
     * @param points
     */
    private onSuccessfulRedeem(points: number) {
        const successfulRedeemDialogConfig: MatDialogConfig = {
            disableClose: true,
            autoFocus: true,
            maxWidth: '750px',
            data: {
                title: 'Thank you!',
                message: points.toFixed(2).toString() + ' points were applied to your outstanding balance.',
                cancel: 'Close',
            },
        };
        this.dialog.open(SuccessfulRedeemDialogComponent, successfulRedeemDialogConfig).afterClosed().subscribe(result => {
          // Trigger Qualtrics feedback compoonent display on dialog close
          utag.link({link_name: "close"}); // Tag: track closing the reedem confirmation pop-up
          //if (!this.qualtricsService.IsInserted()) {
          //  this.qualtricsService.InsertQualtrics();
          //}
        });;
        this.refreshData();
        this.getDWBalance();
    }

    private processInvoice(invoice: IDigitalWalletRewardShip, keyOrder: string[], invoiceKeyToHeaderName: any): any {
        const partDWInvoice: any = {};
        partDWInvoice.business = (invoice.business ? invoice.business.toString() : 'N/A');
        partDWInvoice.invoiceNumber = (invoice.invoiceID ? invoice.invoiceID.toString() : 'N/A');
        partDWInvoice.invoiceDate = (invoice.invoiceDate ? '\t' + moment(invoice.invoiceDate)
            .format('MM-DD-YYYY')
            .toString() : 'NULL');

        partDWInvoice.dueDate = (invoice.dueDate ? '\t' + moment(invoice.dueDate)
            .format('MM-DD-YYYY')
            .toString() : 'NULL');
        partDWInvoice.balance = (invoice.balance ? '\t$' + (+invoice.balance).toFixed(2).toString() : 'NULL');
        partDWInvoice.status = (invoice.status ? '\t' + invoice.status.toString() : 'NULL');
        partDWInvoice.earnedPoints = (invoice.points ? invoice.points.toString() + ' pts' : '0 pts');
        const partialCustomHeaderInvoices = {};

        keyOrder.forEach((key) => {
            if (invoiceKeyToHeaderName[key]) {
                const columnName = invoiceKeyToHeaderName[key];
                partialCustomHeaderInvoices[columnName] = partDWInvoice[key];
            }
        });

        return partialCustomHeaderInvoices;
    }

    private processInvoicesForExcel(search: IInvoiceSearch) {
        this.digitalWalletService.getInvoiceHistory(search).subscribe((dw) => {
            const exportData = [];
            const keyOrder = [
                'business',
                'invoiceNumber',
                'invoiceDate', 'dueDate',
                'balance',
                'status',
                'earnedPoints',
            ];
            const invoiceKeyToHeaderName = {
                business: 'Business',
                invoiceNumber: 'InvoiceNumber',
                invoiceDate: 'InvoiceDate',
                dueDate: 'DueDate',
                balance: 'Balance',
                status: 'Status',
                earnedPoints: 'EarnedPoints',
            };
            dw.forEach((invoice) => {exportData.push(this.processInvoice(invoice, keyOrder, invoiceKeyToHeaderName));});
            const csv = this.convertToCSV(exportData);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            saveAs(blob, 'invoice_history' + new Date().toLocaleDateString() + '.csv');
        });
    }

    private searchInvoiceHistory(index: number) {
        this.isSearching = true;
        this.searchMode = true;
        this.utilityService.clearSubscriptions([this.searchShipmentsSubscription]);

        let key = this.categoryFormGroup.controls.selectCategory.value;
        let value = (key != 'Invoice Date' || key != 'Due Date') ? this.searchFormGroup.controls.keyword.value : '';
        let startDate = this.customDateRangeFormGroup.controls.startDate.value || this.defaultStartDate;
        let endDate = this.customDateRangeFormGroup.controls.endDate.value || startDate;

        this.updateInvoiceData(
            index,
            key.replace(' ', ''),
            value,
            (key == 'Invoice Date' || key == 'Due Date') ? moment(startDate).format('YYYY-MM-DD') : null,
            (key == 'Invoice Date' || key == 'Due Date') ? moment(endDate).format('YYYY-MM-DD') : null);
    }

    private onDataSearchChanged(keyValue: string) {
        let dateRangeStart = moment().subtract(keyValue, 'days').startOf('day');
        let dateRangeEnd = moment().add(7, 'days').startOf('day');

        switch (keyValue) {
            case 'Invoice Date':
                dateRangeStart = moment(this.customDateRangeFormGroup.controls.startDate.value).startOf('day');
                dateRangeEnd = moment(this.customDateRangeFormGroup.controls.endDate.value).endOf('day');
                break;
            case 'Due Date':
                dateRangeStart = moment(this.customDateRangeFormGroup.controls.startDate.value).startOf('day');
                dateRangeEnd = moment(this.customDateRangeFormGroup.controls.endDate.value).endOf('day');
                break;
            default:
                break;
        }

        if (['Invoice Date'].includes(keyValue) || ['Due Date'].includes(keyValue)) {
            this.updateInvoiceData(this.tablePageIndex, this.currentCategoryName, ''
                , moment(dateRangeStart).format('YYYY-MM-DD'), moment(dateRangeEnd).format('YYYY-MM-DD'));
            return;
        } else {
            this.updateInvoiceData(this.tablePageIndex, this.currentCategoryName, this.searchFormGroup.controls.keyword.value
                , null, null);
            return;
        }
    }

    private async keepRedeeming(): Promise<void> {
        let usedPoints = 0;

        const currentUser = this.appState.user$();
        var availablePoints = this.getDWBalance();  // Update this.availablePoints continuously

        if (availablePoints <= 0) {
            if (usedPoints > 0) {
                this.performPostRedemption(usedPoints);
            }
            return;
        }

        const oldestOpenInvoice = await this.digitalWalletService.getOpenInvoices()
                                            .pipe(
                                                map(items =>
                                                    items.reduce(
                                                        (oldest, item) =>
                                                            moment(item.dueDate)
                                                                .isBefore(moment(oldest.dueDate)) ? item : oldest,
                                                        items[0],
                                                    )),
                                            ).toPromise();

        if (isNaN(+oldestOpenInvoice?.balance) || +oldestOpenInvoice?.balance <= 0) {
            // No more applicable invoice.
            return;
        }

        const pointsToRedeem = +oldestOpenInvoice.balance < availablePoints
            ? oldestOpenInvoice.balance
            : this.availablePoints;
        const data = {
            customerid: currentUser?.CustomerId,
            points_to_redeem: parseFloat(pointsToRedeem.toString()).toFixed(2), //As part of DW-119 Issue fix.
            invoiceid: oldestOpenInvoice.invoiceID,
        };

        const redemptionResponse = await this.digitalWalletService.postRedeem(data).toPromise();
        usedPoints += redemptionResponse?.data?.redeemed_points;
        this.availablePoints = redemptionResponse?.data?.available_points;

        if (redemptionResponse?.statusCode !== 201) {
            console.error(`Error when trying to redeem invoice ID ${ oldestOpenInvoice.invoiceID }`, data);
            return;
        }

        await this.keepRedeeming();
    }

    private performPostRedemption(usedPoints: number): void {
        const currentUser = this.appState.user$();
        this.updateInvoiceData(
            this.pageIndex || 0,
            'InvoiceDate',
            '',
            moment(this.defaultStartDate).format('YYYY-MM-DD'),
            moment(this.defaultEndDate).format('YYYY-MM-DD'),
        );

        this.digitalWalletService.postAutoRedeemFlag(currentUser?.CustomerId, true).subscribe(() => {});
        this.onSuccessfulRedeem(usedPoints);
    }

    private resetStatusFilter(statusType: any) {
        let filter_label;

        switch (statusType) {
            case 'Payment Status':
                filter_label = document.getElementById('advanced_filter_payment_status_label');
                this.selectedPaymentStatusOptions = [];
                this.expandPaymentStatusDropdown = false;
                break;
            case 'Points Status':
                filter_label = document.getElementById('advanced_filter_points_status_label');
                this.selectedPointsStatusOptions = [];
                this.expandPointsStatusDropdown = false;
                break;
        }
        filter_label.style.fontSize = '16px';
        filter_label.style.lineHeight = '24px';
    }

    private checkAndValidateInvoiceRangeInputs(): void {
        if (this.minInvoiceBalance !== '') {
            this.AdvancedSearch['startBalance'] = (+this.minInvoiceBalance)?.toFixed(2);
        }
        if (this.maxInvoiceBalance !== '') {
            this.AdvancedSearch['endBalance'] = (+this.maxInvoiceBalance)?.toFixed(2);
        }
    }

    private checkAndValidatePaymentStatus(): void {
        if (this.selectedPaymentStatusOptions.length > 0) {
            const paymentStatusOptions = this.selectedPaymentStatusOptions.map(function (x: string) { return x.toUpperCase(); });
            this.AdvancedSearch['paymentStatus'] = paymentStatusOptions;
        } else {
            delete this.AdvancedSearch['paymentStatus'];
        }
    }

    private checkAndValidatePointsStatus(): void {
        if (this.selectedPointsStatusOptions.length > 0) {
            const pointsStatusOptions = this.selectedPointsStatusOptions.map(function (x: string) { return x.toUpperCase(); });
            this.AdvancedSearch['pointsStatus'] = pointsStatusOptions;
        } else {
            delete this.AdvancedSearch['pointsStatus'];
        }
    }

    private fillRemainingAdvancedSearchFields(): void {
        this.AdvancedSearch['pageNumber'] = 1;
        this.AdvancedSearch['pageSize'] = 20;
        this.AdvancedSearch['isExportExcel'] = 0;
        this.AdvancedSearch['inputType'] = 'Advanced';
        this.tablePageIndex = 1;
        this.updatePaginateConfig();
    }

    private resetAdvancedFilterElements() {
        // Reset all filters here
        this.selectedDateRadioOption = undefined;
        var element = document.getElementById('date_filter_form_container');
        $(element).hide();

        this.expandDatePicker = false;
        element = document.getElementById('advanced_filter_date_picker');
        element.style.display = 'none';

        // TODO: Reset all components in custom date filter and picker

        this.minInvoiceBalance = '0';
        this.maxInvoiceBalance = '100000';

        this.resetStatusFilter('Payment Status');
        this.resetStatusFilter('Points Status');

        element = document.getElementById('table_filters_wrapper');
        $(element).hide();

        this.showInvoiceFilterErrorMessage = false;
        this.invoiceFilterErrorMessage = 'Minimum value is greater than maximum value.';
        this.checkedInvoiceLists.length = 0;
        this.isAdvanceSearchEnabled = false;
        this.AdvancedSearch = {};
        this.advancedFilterStartDate = '';
        this.advancedFilterEndDate = '';
    }

    // Refactoring for removeAdvancedFilterOption ------
    private deleteInvoiceFilterDateRange() {
        // TODO: Delete any components for custom date filter and picker
        delete this.AdvancedSearch['invoiceStartDate'];
        delete this.AdvancedSearch['invoiceEndDate'];
        delete this.AdvancedSearch['dueStartDate'];
        delete this.AdvancedSearch['dueEndDate'];
        this.selectedDateRadioOption = undefined;
        const dateElement = document.getElementById('date_filter_form_container');
        $(dateElement).hide();
        this.expandDatePicker = false;
        this.advancedFilterStartDate = '';
        this.advancedFilterEndDate = '';
    }

    private deleteInvoiceFilterBalance() {
        delete this.AdvancedSearch['startBalance'];
        delete this.AdvancedSearch['endBalance'];
        this.minInvoiceBalance = '0';
        this.maxInvoiceBalance = '100000';
    }
    
    isMouseInside(event: MouseEvent): boolean {
      const bounds = this.getViewportBounds();
      return event.clientX >= bounds.left && event.clientX <= bounds.right &&
            event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    }

    getViewportBounds(): DOMRect {
      return document.documentElement.getBoundingClientRect();
    }
}
